import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  CURRENCY_RATE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'curreny' })
export default class Counter extends VuexModule {
  @Action
  fetchCurrencyRate() {
    return Vue.axios({
      url: BASE_URL + CURRENCY_RATE,
      data: '',
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
